export default __webpack_public_path__ + "static/rovo-menu-light-f4692f7a04a9398d4edf9c5fdeb796a18c5bf36d3d994fd6883d46d763e9c91e.png";